import { render, staticRenderFns } from "./ActionsNavigateStudies.vue?vue&type=template&id=5e4261df"
import script from "./ActionsNavigateStudies.vue?vue&type=script&lang=js"
export * from "./ActionsNavigateStudies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports